export enum OnboardingV2DealSizeBucket {
  Unknown = "unknown",
  Under1k = "under_1k",
  _1kTo5k = "1k_to_5k",
  _5kTo25k = "5k_to_25k",
  _25kTo100k = "25k_to_100k",
  _100kPlus = "100k_plus",
}
